// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SimpleIntakeSurveyModel {
    static getAttributeTypeMap() {
        return SimpleIntakeSurveyModel.attributeTypeMap;
    }
}
SimpleIntakeSurveyModel.discriminator = undefined;
SimpleIntakeSurveyModel.additionalProperties = false;
SimpleIntakeSurveyModel.attributeTypeMap = [
    {
        "name": "surveyId",
        "baseName": "surveyId",
        "type": "number"
    },
    {
        "name": "sourceId",
        "baseName": "sourceId",
        "type": "number"
    },
    {
        "name": "systemId",
        "baseName": "systemId",
        "type": "number"
    },
    {
        "name": "answers",
        "baseName": "answers",
        "type": "Array<SimpleIntakeSurveyAnswerModel>"
    },
];
//# sourceMappingURL=simpleIntakeSurveyModel.js.map